import styled from "styled-components"

const StyledStepFifth = styled.div`
  .error-block {
    max-width: 600px;
    p {
      font-size: 12px;
      line-height: 24px;
      letter-spacing: 1.4px;
      font-weight: 500;
      color: #fc0303;
    }
  }
  .last-step {
    &-wrapper {
      display: flex;
      align-items: flex-start;
      /* .order-courier-form__info {
        flex-basis: 414px;
        max-width: 414px;
      } */
    }
    &-checks {
      flex: 1;
      label {
        margin: 0 0 30px;
        span {
          font-size: 16px;
          line-height: 24px;
        }
      }
      .inp-error {
        top: initial;
        bottom: calc(100%);
        text-transform: uppercase;
      }
    }
    @media screen and (max-width: 1200px) {
      &-wrapper {
        .order-courier-form__info {
          flex-basis: 340px;
          max-width: 340px;
        }
      }
    }
    @media screen and (max-width: 900px) {
      &-wrapper {
        flex-flow: wrap;
        .order-courier-form__info {
          flex-basis: 100%;
          max-width: 100%;
        }
      }
      &-checks {
        flex-basis: 100%;
        max-width: 100%;
        margin: 30px 0 0;
        label {
          margin: 0 0 30px;
        }
      }
    }
  }
`

export default StyledStepFifth
